import React, { useState } from 'react';
import '../css/logoutPopUp.css';
import { uploadProfilePicture } from "../service";
import { CircleLoader } from 'react-spinners';
import loadingImage from '../images/login-shape.png'
import { useSelector } from 'react-redux';

export default function ChangeProfilePhoto({ isOpen, onClose, onConfirm }) {
    const dashboardDetails = useSelector((state) => state.Dashboard);

    const [file, setFile] = useState("");
    const [previewUrl, setPreviewUrl] = useState("");
    const [loading, setLoading] = useState(false);  // Start with no loading
    const userId = dashboardDetails.userId
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            // const maxSize = 100 * 1024; // 100 KB in bytes
            const maxSize = 1 * 1024 * 1024;
            if (selectedFile.size > maxSize) {
                alert("File size exceeds the maximum limit of 1 MB.");
                e.target.value = ""; // Reset the file input
                return;
            }

            setFile(selectedFile);

            // Create a preview URL for the selected file
            const preview = URL.createObjectURL(selectedFile);
            setPreviewUrl(preview);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            alert("Please select a file to upload.");
            console.error('Please select a file to upload.');
            return;
        }

        setLoading(true);  // Start loading
        try {
            const response = await uploadProfilePicture(file, userId, 'uploads/uploadAvatar');

            console.log("🚀 ~ handleSubmit ~ response: imageupload", file)

            console.log('File uploaded successfully:', response.data);
            alert("File uploaded successfully");
            handleClose();
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            setLoading(false);  // End loading
        }
    };

    const handleClose = () => {
        setFile("");
        setPreviewUrl("");  // Reset preview URL
        onClose();  // Trigger the actual close
    };

    // Return null conditionally but ensure hooks are called
    if (!isOpen) return null;

    return (
        <div className="modal-overlay1">
            <div className="modal-content1">
                {loading ? (
                    // Display only the loader when loading
                    <div className="align-items-center border-popupsec">
                        <div className="spinnerLoader">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <img src={loadingImage} alt="Loading..." className="loading-image" />
                        </div>
                    </div>
                ) : (
                    // Display the form when not loading
                    <form onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-start align-items-center gap-4 border-popupsec">
                            <div className="">
                                <label htmlFor="file-input" className='uploadImg-btn'>Choose Image</label>
                                <input accept="image/*" type="file" id="file-input" onChange={handleFileChange} />
                            </div>
                            {previewUrl ? (
                                <div className="image-preview">
                                    <img src={previewUrl} alt="Image Preview" className="img-fluid" style={{ width: '60px', height: '60px' }} />
                                </div>
                            ) : (
                                <span className="noFile-text">No file chosen.</span>
                            )}
                        </div>
                        <div className="d-flex justify-content-end mt-btnProfile">
                            <button type="submit" className='btn-confirm1'>Save</button>
                            <button type="button" className='btn-cancel1' onClick={handleClose}>Cancel</button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
